module.exports = __webpack_public_path__ + "static/media/iac.27e4884e.png";